import { deskBreakpoint, mobileBreakpoint, tabBreakpoint } from '../../../../bpl-tools/utils/data';
import { getBackgroundCSS, getBorderCSS, getBoxCSS, getTypoCSS, isValidCSS, } from "../../../../bpl-tools/utils/getCSS";

const Style = ({ attributes, id }) => {

	const { column = {}, align, Styles = {}, theme = '' } = attributes || {};

	const { heading, content, container } = Styles;

	const { title, subTitle, button } = heading;
	const { question, answer, icon, categoryTitle } = content;


	const mainSl = `#${id}`;
	const blockSl = `${mainSl} .faq-main-wrapper`;
	const wrapperSl = `${blockSl} .faq-container-style`;
	const containerSl = `${wrapperSl} .faa-section-main`
	/*--heading---*/
	const headingContainerSl = `${wrapperSl} .header-Container`;
	const headingTitleSl = `${wrapperSl} .faq-header-title`;
	const headingSubTitleSl = `${wrapperSl} .faq-header-subtitle`;
	const btnSl = `${wrapperSl} .category-btn`;
	const cardSl = `${wrapperSl} .faq-card`;
	const numberSl = `${wrapperSl} .faq-number`;
	/*---content---*/
	const categoryTitleSl = `${wrapperSl} .faq-title`;
	const contentWrapperSl = ` ${wrapperSl} .content-Container`;
	const questionDivSl = `${wrapperSl} .faq-question`;
	const questionSl = `${wrapperSl} .faq-question-title`;
	const answerDivSl = `${wrapperSl} .faq-answer`;
	const answerSl = `${wrapperSl} .faq-answer-para`;
	const iconSl = `${wrapperSl} .faq-icon svg `;
	const cardThemeFour = `${wrapperSl} .faq-content`;
	const themeFourSectionSl = `${wrapperSl} .themeFourSection`


	return <style dangerouslySetInnerHTML={{
		__html: `
		${getTypoCSS("", heading.title.typo).googleFontLink} 
		${getTypoCSS("", heading.subTitle.typo).googleFontLink} 
	    ${getTypoCSS("", content.question.typo).googleFontLink}  
        ${getTypoCSS("", content.answer.typo).googleFontLink} 
        ${getTypoCSS("", content?.categoryTitle?.typo).googleFontLink} 
        ${getTypoCSS("", heading.button.typo).googleFontLink} 
		${getTypoCSS("", heading.title.typo).googleFontLink} 

		${getTypoCSS(headingTitleSl, heading.title.typo).styles}  
		${getTypoCSS(headingSubTitleSl, heading.subTitle.typo).styles}  
	    ${getTypoCSS(questionSl, content?.question?.typo).styles} 
        ${getTypoCSS(answerSl, content?.answer?.typo).styles}  
        ${getTypoCSS(categoryTitleSl, content?.categoryTitle?.typo).styles}  
		${getTypoCSS(btnSl, heading?.button?.typo).styles} 
		${getTypoCSS(numberSl, heading.title.typo).styles}   

		${containerSl}{
		   padding: ${getBoxCSS(container?.padding?.desktop)};
		   ${getBorderCSS(container?.border)};
		   ${getBackgroundCSS(container?.background)}
		}
		${tabBreakpoint}{ 
		   ${containerSl}{ 
			   padding: ${getBoxCSS(container?.padding?.tablet)};
			} 
		}

		${mobileBreakpoint}{ 
		   ${containerSl}{ 
			   padding: ${getBoxCSS(container?.padding?.mobile)};
			} 
		}
		${headingContainerSl}{
		  ${getBackgroundCSS(heading?.bg)}
		}
		${deskBreakpoint}{
		   ${contentWrapperSl}{
		      grid-template-columns: repeat(${align ? column?.desktop : 2}, 1fr);
			  column-gap : ${column?.gapY};
			  row-gap : ${column?.gapX};
		   }
		}
		${tabBreakpoint}{ 
		   ${contentWrapperSl}{ 
			   grid-template-columns: repeat(${align ? column?.tablet : 1}, 1fr);
			   column-gap : ${column?.gapY};
			   row-gap : ${column?.gapX};
			} 
		}
		${mobileBreakpoint}{ 
		   ${contentWrapperSl}{ 
			   grid-template-columns: repeat(${align ? column?.mobile : 1}, 1fr);
			   column-gap : ${column?.gapY};
			   row-gap : ${column?.gapX};
			} 
		}	
		${headingTitleSl}{
		   color: ${title?.colors?.color};
		   text-align : ${title?.textAlign};
		}
		${headingSubTitleSl}{
		   color: ${subTitle?.colors?.color};
		   text-align : ${subTitle?.textAlign};
		}

		${btnSl}{
		   color: ${button?.colors?.color};
		   padding: ${getBoxCSS(button?.padding?.desktop)};
		   ${getBorderCSS(button?.border)};
		   ${getBackgroundCSS(button?.background)}
		}
		${tabBreakpoint}{ 
		   ${btnSl}{ 
			   padding: ${getBoxCSS(button?.padding?.tablet)};
			} 
		}

		${mobileBreakpoint}{ 
		   ${btnSl}{ 
			   padding: ${getBoxCSS(button?.padding?.mobile)};
			} 
		}

		${categoryTitleSl}{
           color: ${categoryTitle?.colors?.color};
		}

		${questionDivSl}{
		 ${getBackgroundCSS(question?.background)} 
		 padding: ${getBoxCSS(question?.padding?.desktop)};
		}
		${tabBreakpoint}{ 
		   ${questionDivSl}{ 
			   padding: ${getBoxCSS(question?.padding?.tablet)};
			} 
		}

		${mobileBreakpoint}{ 
		   ${questionDivSl}{ 
			   padding: ${getBoxCSS(question?.padding?.mobile)};
			} 
		}

		${questionSl}{
          color: ${question?.colors?.color};
		}
		

		${answerDivSl}{
		  ${getBackgroundCSS(answer?.background)}
		}
		${answerSl}{
		  padding: ${getBoxCSS(answer?.padding?.desktop)};
		}
		${tabBreakpoint}{ 
		   ${answerSl}{ 
			   padding: ${getBoxCSS(answer?.padding?.tablet)};
			} 
		}

		${mobileBreakpoint}{ 
		   ${answerSl}{ 
			   padding: ${getBoxCSS(answer?.padding?.mobile)};
			} 
		}

		${answerSl}{
		  color: ${answer?.colors?.color};
		}

		${iconSl}{	  
		  ${isValidCSS('width', icon?.size?.desktop)}
		  ${isValidCSS('height', icon?.size?.desktop)}
		  fill: ${icon?.colors?.color};
		  ${getBorderCSS(icon?.border)};
		  ${getBackgroundCSS(icon?.background)}
		  
		}
		${deskBreakpoint}{
		   ${iconSl}{ 
		      padding: ${getBoxCSS(icon?.padding?.desktop)};
	       }
		}
		${tabBreakpoint}{ 
		   ${iconSl}{ 
			   padding: ${getBoxCSS(icon?.padding?.tablet)};
			   width: ${icon?.size?.tablet};
			   height: ${icon?.size?.tablet};
			} 
		}

		${mobileBreakpoint}{ 
		   ${iconSl}{ 
			   padding: ${getBoxCSS(icon?.padding?.mobile)};
			   width: ${icon?.size?.mobile};
			   height: ${icon?.size?.mobile};
			} 
		}
	
		${theme === 'themeTwo' && `${cardSl}{
		   padding: ${getBoxCSS(container?.padding?.desktop)};
		   ${getBackgroundCSS(container?.background)}
		   ${getBorderCSS(container?.border)};	
		
		}`}

		${theme === 'themeTwo' && `${numberSl}{
		     color: ${title?.colors?.color};
		}`}
		${tabBreakpoint}{ 
	     	${theme === 'themeTwo' && `${cardSl}{
		        padding: ${getBoxCSS(container?.padding?.tablet)};
		    }`}
		}
		${mobileBreakpoint}{ 
		  ${theme === 'themeTwo' && `${cardSl}{
		   padding: ${getBoxCSS(container?.padding?.mobile)};		  
		   }`}
		}	
		${theme === 'themeFour' && `
			${cardThemeFour} {
			     padding: ${getBoxCSS(answer?.padding?.desktop)};
			 }
			${themeFourSectionSl}{
				border: 1px solid ${question?.colors?.color}; 
			}
			 
		   ${tabBreakpoint}{ 
		      ${cardThemeFour}{ 
			   padding: ${getBoxCSS(answer?.padding?.tablet)};
			  } 
		    }

		   ${mobileBreakpoint}{ 
		        ${cardThemeFour}{ 
			      padding: ${getBoxCSS(answer?.padding?.mobile)};
			    } 
		    }
		`
			};

		 
	`}} />;
}
export default Style;


